export default __webpack_public_path__ + "static/media/agrolider.1e13cd0f.jpg";